import { createFileRoute } from '@tanstack/react-router'

import CoverageSheetContent from '@/components/sheets/coverage/coverage-sheet-content'
import { coverageSheetPreload } from '@/components/sheets/coverage/coverage-sheet-preload'

export const Route = createFileRoute('/app/data/coverages/$uuid/')({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    coverageSheetPreload(params.uuid, queryClient),
})

function RouteComponent() {
  const { uuid } = Route.useParams()

  return <CoverageSheetContent coverageUuid={uuid} />
}
